import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/transaction', // 交易
  name: 'transaction',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.transaction',
    requiresAuth: true,
    icon: 'icon-apps',
    order: 3,
  },
  children: [
    {
      path: 'productManage', // The midline path complies with SEO specifications
      name: 'productManage',
      component: () => import('@/views/transaction/product/index.vue'),
      meta: {
        locale: 'menu.productManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'categoryManage', // The midline path complies with SEO specifications
      name: 'categoryManage',
      component: () => import('@/views/transaction/category/index.vue'),
      meta: {
        locale: 'menu.categoryManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
